import { hydrateRoot, createRoot } from "react-dom/client";
import App from "./App.tsx";
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/plus-jakarta-sans/800.css";
import "./index.css";
import { SecureAuthProvider } from "@/hooks/useSecureAuth";
import { SsrDataProvider } from "@/contexts/SsrDataContext";
import { HYDRATE_PATHS } from "@/i18n/routes";
import { readSsrPayload } from "@/lib/ssrPayload";
import { initWebVitals } from "@/lib/webVitals";

const rootElement = document.getElementById("root")!;
const ssrPayload = readSsrPayload();

// Check if we have SSR-rendered content to hydrate
const hasSSRContent =
  rootElement.innerHTML.trim() !== "" &&
  !rootElement.innerHTML.trim().startsWith("<!--");

const shouldHydrate =
  hasSSRContent && HYDRATE_PATHS.has(window.location.pathname);

const app = (
  <SsrDataProvider initialRatingStats={ssrPayload?.ratingStats ?? null}>
    <SecureAuthProvider>
      <App ssrLocation={shouldHydrate ? window.location.pathname : undefined} />
    </SecureAuthProvider>
  </SsrDataProvider>
);

if (shouldHydrate) {
  hydrateRoot(rootElement, app);
} else {
  // SPA routes (or empty shell): mount fresh to avoid hydrating the wrong page
  createRoot(rootElement).render(app);
}

// Report Core Web Vitals to GA4 (client-only, after the app mounts).
initWebVitals();
